module.exports = {
  id: 38,
  name: 'Step Jumps',
  categories: ['cardio', 'strength', 'legs', 'explosiveness'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Power',
  points: 21,
  instructions:
    'Step jumps are powerful! Jump onto a sturdy step or surface, then jump back down! This builds incredible leg power and jumping ability!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to jump onto the step? Let us build incredible leg power and explosiveness!',
    },
    {
      time: 3,
      text: 'Stand in front of a sturdy step, feet shoulder-width apart!',
    },
    {
      time: 6,
      text: 'Keep your core engaged and get ready to explode!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Bend your knees and swing your arms back!',
    },
    // SET 1 - 8 step jumps
    {
      time: 12,
      text: 'Perfect position! Feet shoulder-width apart, ready to jump!',
    },
    {
      time: 15,
      text: 'Number 1! Bend your knees and swing your arms back!',
    },
    {
      time: 18,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 21,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 24,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 27,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 30,
      text: 'Number 2! Bend your knees and swing your arms back!',
    },
    {
      time: 33,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 36,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 39,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 42,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 45,
      text: 'Number 3! Bend your knees and swing your arms back!',
    },
    {
      time: 48,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 51,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 54,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 57,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 60,
      text: 'Number 4! Bend your knees and swing your arms back!',
    },
    {
      time: 63,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 66,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 69,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 72,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 75,
      text: 'Number 5! Bend your knees and swing your arms back!',
    },
    {
      time: 78,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 81,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 84,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 87,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 90,
      text: 'Number 6! Bend your knees and swing your arms back!',
    },
    {
      time: 93,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 96,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 99,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 102,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 105,
      text: 'Number 7! Bend your knees and swing your arms back!',
    },
    {
      time: 108,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 111,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 114,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 117,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 120,
      text: 'Number 8! Bend your knees and swing your arms back!',
    },
    {
      time: 123,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 126,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 129,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 132,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 135,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 1 - 30 seconds
    {
      time: 138,
      text: 'Take a deep breath in and out, you are building incredible power!',
    },
    {
      time: 141,
      text: 'Shake out your legs and feet, get ready for round two!',
    },
    {
      time: 144,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 147,
      text: 'Remember to bend your knees and explode up!',
    },
    {
      time: 150,
      text: '3, 2, 1, START! Bend your knees and swing your arms back!',
    },
    // SET 2 - 8 step jumps
    {
      time: 153,
      text: 'Perfect position! Feet shoulder-width apart, ready to jump!',
    },
    {
      time: 156,
      text: 'Number 1! Bend your knees and swing your arms back!',
    },
    {
      time: 159,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 162,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 165,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 168,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 171,
      text: 'Number 2! Bend your knees and swing your arms back!',
    },
    {
      time: 174,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 177,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 180,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 183,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 186,
      text: 'Number 3! Bend your knees and swing your arms back!',
    },
    {
      time: 189,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 192,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 195,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 198,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 201,
      text: 'Number 4! Bend your knees and swing your arms back!',
    },
    {
      time: 204,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 207,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 210,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 213,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 216,
      text: 'Number 5! Bend your knees and swing your arms back!',
    },
    {
      time: 219,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 222,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 225,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 228,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 231,
      text: 'Number 6! Bend your knees and swing your arms back!',
    },
    {
      time: 234,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 237,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 240,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 243,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 246,
      text: 'Number 7! Bend your knees and swing your arms back!',
    },
    {
      time: 249,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 252,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 255,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 258,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 261,
      text: 'Number 8! Bend your knees and swing your arms back!',
    },
    {
      time: 264,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 267,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 270,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 273,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 276,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 2 - 30 seconds
    {
      time: 279,
      text: 'Take a deep breath in and out, you are building incredible power!',
    },
    {
      time: 282,
      text: 'Shake out your legs and feet, get ready for the final round!',
    },
    {
      time: 285,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 288,
      text: 'Remember to bend your knees and explode up!',
    },
    {
      time: 291,
      text: '3, 2, 1, START! Bend your knees and swing your arms back!',
    },
    // SET 3 - 8 step jumps
    {
      time: 294,
      text: 'Perfect position! Feet shoulder-width apart, ready to jump!',
    },
    {
      time: 297,
      text: 'Number 1! Bend your knees and swing your arms back!',
    },
    {
      time: 300,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 303,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 306,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 309,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 312,
      text: 'Number 2! Bend your knees and swing your arms back!',
    },
    {
      time: 315,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 318,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 321,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 324,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 327,
      text: 'Number 3! Bend your knees and swing your arms back!',
    },
    {
      time: 330,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 333,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 336,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 339,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 342,
      text: 'Number 4! Bend your knees and swing your arms back!',
    },
    {
      time: 345,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 348,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 351,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 354,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 357,
      text: 'Number 5! Bend your knees and swing your arms back!',
    },
    {
      time: 360,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 363,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 366,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 369,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 372,
      text: 'Number 6! Bend your knees and swing your arms back!',
    },
    {
      time: 375,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 378,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 381,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 384,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 387,
      text: 'Number 7! Bend your knees and swing your arms back!',
    },
    {
      time: 390,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 393,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 396,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 399,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 402,
      text: 'Number 8! Bend your knees and swing your arms back!',
    },
    {
      time: 405,
      text: 'Explode up and jump onto the step!',
    },
    {
      time: 408,
      text: 'Land softly with bent knees and control!',
    },
    {
      time: 411,
      text: 'Now jump back down to the ground!',
    },
    {
      time: 414,
      text: 'Land softly and get ready for the next jump!',
    },
    {
      time: 417,
      text: 'Incredible work! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 420,
      text: 'Amazing work! You did 24 step jumps and built incredible power!',
    },
    {
      time: 423,
      text: 'You are getting super explosive and powerful! You are a step jump master!',
    },
    {
      time: 426,
      text: 'Great job, power champion! You are building incredible skills!',
    },
  ],
};
